import { EditIcon, TrashIcon } from '@calizahq/react-components-v2'
import { Agent } from '@sales-app/types/Agent'
import { formatInTimeZone } from 'date-fns-tz'
import React from 'react'

import { BottomSheet, Tag } from '@/components'
import { useToggle } from '@/hooks'

import { DeleteAgent } from './DeleteAgent/DeleteAgent'
import { EditAgentForm } from './EditAgent/EditAgentForm'

export const AgentColumns = (refetchOnSuccess: () => void) => {
  return [
    {
      Header: 'Name',
      accessor: 'name',
      minWidth: 100,
      canResize: false,
    },
    {
      Header: 'Role',
      accessor: 'role',
      width: 50,
      canResize: false,
    },
    {
      Header: 'Tags',
      Cell: ({ row }: { row: { original: Agent } }) => {
        const agent = row.original || {}

        return (
          <div className="flex w-full items-center justify-center">
            {!!agent?.corporateHousing && (
              <Tag className=" mr-1 text-sm text-tag-green-dark tag-green-light">Corporate Housing</Tag>
            )}
            {!!agent.standard && <Tag className="mr-1 text-sm text-tag-grey-dark tag-grey-light">Standard</Tag>}
          </div>
        )
      },
    },
    {
      Header: 'Supervisor',
      accessor: 'supervisor.name',
      width: 100,
      canResize: false,
    },
    {
      Header: 'Current Status',
      accessor: 'currentStatus',
      width: 100,
      canResize: false,
      Cell: ({ value }: { value: string }) => {
        const className = getAgentStatusClassNames(value)
        return (
          <div className="flex w-full items-center justify-center">
            <div
              className={` w-30 cursor-pointer rounded-lg px-3 py-2 text-center capitalize leading-140
               ${className}`}
            >
              {value ? value : 'Unavailable'}
            </div>
          </div>
        )
      },
    },
    {
      Header: 'Current Status Change',
      accessor: 'lastStatusChange',
      minWidth: 100,
      canResize: false,
      Cell: function _Cell({ value = '' }: { value: string }) {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        try {
          const time = formatInTimeZone(value, timezone, 'MMM d yyyy, HH:mm a z')
          return time
        } catch (e) {
          return ''
        }
      },
    },
    {
      accessor: 'id',
      width: 50,
      canResize: false,
      Cell: ({ row }: { row: { original: Agent } }) => {
        const { isShown: editModalShown, toggle: editModalToggle } = useToggle()
        const { isShown: deleteModalShown, toggle: deleteModalToggle } = useToggle()

        return (
          <>
            <button
              className={'ml-2 mr-2 grid h-5 w-5 items-center justify-center'}
              onClick={editModalToggle}
              title="Edit Agent"
            >
              <EditIcon className="text-green-300" width={16} />
            </button>
            <button
              className={'ml-2 mr-2 grid h-5 w-5 items-center justify-center'}
              onClick={deleteModalToggle}
              title="Delete Agent"
            >
              <TrashIcon className="text-red-300" width={16} />
            </button>
            <BottomSheet isVisible={editModalShown} mobileFullHeight={true} onClose={editModalToggle}>
              <EditAgentForm agent={row.original} refetchOnSuccess={refetchOnSuccess} toggle={editModalToggle} />
            </BottomSheet>
            <BottomSheet isVisible={deleteModalShown} mobileFullHeight={true} onClose={deleteModalToggle}>
              <DeleteAgent agentId={row.original.id} refetchOnSuccess={refetchOnSuccess} toggle={deleteModalToggle} />
            </BottomSheet>
          </>
        )
      },
    },
  ]
}

export const getAgentStatusClassNames = (status: string) => {
  switch (status) {
    case 'Available':
      return 'bg-green-200 text-white'
    case 'Busy':
      return 'bg-yellow-200 text-action-input'
    case 'Unavailable':
      return 'bg-red-200 text-white'
    default:
      return 'bg-border-secondary  text-action-input'
  }
}
